import { render, staticRenderFns } from "./LandingAppRatings.vue?vue&type=template&id=6f84ad05&scoped=true"
import script from "./LandingAppRatings.vue?vue&type=script&lang=js"
export * from "./LandingAppRatings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f84ad05",
  null
  
)

export default component.exports